import { AbilityBuilder, PureAbility } from '@casl/ability';
import type { AppAction, AppSubject, AppRole } from 'types/ability';

export type AppAbility = PureAbility<[AppAction, AppSubject]>;

export function buildAbilityFor(role: AppRole): AppAbility {
  const { can, build } = new AbilityBuilder<AppAbility>(PureAbility);

  switch (role) {
    case 'super_admin':
      can('manage', 'all');
      break;

    case 'tenant_admin':
      can('manage', 'User');
      can('manage', 'Client');
      can('manage', 'ChatSession');
      can('manage', 'ProcessMap');
      can('manage', 'Flowchart');
      can('manage', 'Invoice');
      can('manage', 'Payment');
      can('manage', 'Settings');
      can('read', 'Dashboard');
      break;

    case 'tenant_user':
      can('read', 'Dashboard');
      can('create', 'ChatSession');
      can('read', 'ChatSession');
      can('update', 'ChatSession');
      can('read', 'ProcessMap');
      can('create', 'ProcessMap');
      can('read', 'Flowchart');
      can('create', 'Flowchart');
      can('read', 'Client');
      break;
  }

  return build();
}

// Default ability (unauthenticated) — no permissions
export const defaultAbility = new PureAbility<[AppAction, AppSubject]>([]);
